import { gql } from '@apollo/client';
export default gql`
  query Buyer {
    buyer {
      userId
      firstName
      lastName
      recommendationPreferences {
        districts {
          id
          displayTitle
        }
        industries
        businessTypes
        price {
          min
          max
        }
        excludePoa
        keywords
      }
      subscription {
        subscriptionStatus
      }
    }
  }
`;
